const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/accept-invite.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/pro/accept-invite')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});